import axios from 'axios'

const baseUrl = process.env.VUE_APP_BASE_API

// 将对象转换为 application/x-www-form-urlencoded 字符串
function toFormUrlEncoded(data: Record<string, any>): string {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&')
}

// 创建 axios 实例
const service = axios.create({
  baseURL: baseUrl,
  timeout: 60000,
  withCredentials: false
})

// 请求拦截
service.interceptors.request.use(
  (config: any) => {
    // 设置默认 Content-Type
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    }

    const method = config.method?.toLowerCase()

    // 处理 GET 请求参数 (URL 参数)
    if (method === 'get' && config.params) {
      config.paramsSerializer = (params: any) => toFormUrlEncoded(params)
    }

    // 处理 POST 的 form-urlencoded (请求体)
    if (
      method === 'post' &&
      config.headers['Content-Type']?.includes('application/x-www-form-urlencoded') &&
      config.data &&
      typeof config.data === 'object'
    ) {
      config.data = toFormUrlEncoded(config.data)
    }

    return config
  },
  (error: any) => Promise.reject(error)
)
// 响应拦截
service.interceptors.response.use(
  (response: any) => response.data,
  (error: any) => {
    console.error('请求出错：', error)
    return Promise.reject(error)
  }
)

// Http 封装
export class Http {
  static async get(url: string, params?: any, config?: any) {
    return await service.get(url, { params, ...(config || {}) })
  }

  static async post(url: string, data?: any, config?: any) {
    return await service.post(url, data, config)
  }
}

export default service